//import Moment from "moment";

const getCount = (state) => {
	return state.localizacoes.length;
}

const ultimaAtualizacaoListaLocalizacao = (state) => {
	if (state.ultimaAtualizacaoListaLocalizacao == null) {
		return true;
	}
	else if(!state.localizacoes)
	{
		return true;
	}
	else {
		const d = new Date();
		let hour = d.getHours();
		return (
			state.localizacoes.length == 0 ||
			hour - state.ultimaAtualizacaoListaLocalizacao.getHours() > 0
		);
	}
}

export default {
	getCount,
	ultimaAtualizacaoListaLocalizacao
}